export enum DIALOGUE_STATES {
  APPROVE = 'APPROVE',
  EDIT = 'EDIT',
  CLOSED = 'CLOSED',
  APPROVED = 'APPROVED',
  EDITED = 'EDITED',
  ERROR = 'ERROR',
  SUBMIT_A_TICKET = 'SUBMIT_A_TICKET',
}
